import { USERS_LIST_GROUPS_COLLAPSE_THRESHOLD } from '../../dashboard/constants';

import linkedTagsUrl from './linkedTags.html';

class LinkedTagsCtrl {
  constructor(Authentication, $scope, $timeout) {
    'ngInject';

    Object.assign(this, { Authentication, $scope, $timeout });
  }

  toggle =
    (state) =>
    (trigger = true) => {
      this.shouldShowAll = state;
      if (trigger) {
        this.$timeout(() => {
          this.onCollapseChange?.();
          this.$scope.$emit('vsRepeatTrigger');
        });
      }
    };

  $onInit() {
    this.displayedItemsLimit = USERS_LIST_GROUPS_COLLAPSE_THRESHOLD;

    this.showAll = this.toggle(true);
    this.showLess = this.toggle(false);

    this.showLess(false);
  }
}

export default {
  controller: LinkedTagsCtrl,
  controllerAs: 'ctrl',
  templateUrl: linkedTagsUrl,
  bindings: {
    src: '=',
    comma: '=?',
    shouldShowAll: '=isExpanded',
    onCollapseChange: '&?',
  },
};
